import React from 'react';
import { useTranslation } from '../../context/LanguageContext';

const TextareaField = ({ label, value, onChange, placeholder, rows = 3, error }) => {
    const { isRTL } = useTranslation();
    
    return (
        <div>
            <label className={`block text-sm font-medium text-gray-700 mb-1 ${isRTL ? 'text-right' : 'text-left'}`}>
                {label}
            </label>
            <textarea
                rows={rows}
                className={`
                    mt-1 block w-full rounded-md border-gray-300 shadow-sm
                    focus:border-primary-500 focus:ring-primary-500 sm:text-sm
                    ${error ? 'border-red-300' : ''}
                    ${isRTL ? 'text-right' : 'text-left'}
                `}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
            />
            {error && (
                <p className={`mt-2 text-sm text-red-600 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {error}
                </p>
            )}
        </div>
    );
};

export default TextareaField;
